<template>
  <div class="ai-section">
    <div class="section-title">
      <b>Firm Notes & Documents</b>
    </div>

    <div class="focus-box">
      <strong>MO-specific logic:</strong>
      analyse questions with notes / without notes and attached documents, not auditor note sentiment.
    </div>

    <div
        class="compact-row"
        v-for="item in notes"
        :key="item.label"
    >
      <span>{{ item.label }}</span>
      <strong>{{ formatDisplayValue(item.value) }}</strong>
    </div>

    <div class="compact-row">
      <span>Total documents added</span>
      <strong>{{ formatNumber(documentsCount) }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotesDocumentsBlock',

  props: {
    notes: Array,
    documentsCount: Number,
    formatNumber: Function,
    formatDisplayValue: Function
  }
};
</script>

<style scoped>
.ai-section {
  border-top: 1px solid #e1e1e1;
  padding-top: 14px;
  margin-bottom: 22px;
}

.section-title {
  margin-bottom: 12px;
  color: #111;
  font-size: 14px;
  font-weight: 900;
}

.focus-box {
  background: #fff7e8;
  border-left: 4px solid #f0ad4e;
  padding: 10px 12px;
  margin-bottom: 14px;
  color: #4a4a4a;
  font-size: 12px;
  line-height: 1.45;
}

.compact-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #333;
  font-size: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #e8e8e8;
}

.compact-row:last-child {
  border-bottom: 0;
}

.compact-row strong {
  color: #111;
}

.compact-row em {
  color: #777;
  font-size: 11px;
  font-style: normal;
}
</style>
